import styled from 'styled-components';
import { animation } from './animation';
export var ModalOverlay = styled.div.withConfig({
  displayName: "ModalOverlay",
  componentId: "sc-ts9r57-0"
})(["display:", ";position:fixed;z-index:", ";top:0;bottom:0;left:0;right:0;background-color:rgb(0 0 0 / 0.4);", ";"], function (_ref) {
  var $display = _ref.$display;
  return $display;
}, function (_ref2) {
  var _ref2$zIndex = _ref2.zIndex,
    zIndex = _ref2$zIndex === void 0 ? 10000000 : _ref2$zIndex;
  return zIndex;
}, animation);